/* eslint-disable react/require-default-props */
import React, { Component, PropTypes } from 'react';

import { NitroNavBar, NitroDrawer, NitroPlaceholder } from 'nitro-components';

import { pushGAAction } from '@src/utils/gtm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../actions';

import AllocateDifferentDriverTabs from './AllocateDifferentDriverTabs';

import DriverAllocationApi from '../../../../api/DriverAllocationApi';

import { notify } from '../../../../components/libs/notification';

import {
  ALLOCATION_DETAIL_HEADING,
  CHANGE_DRIVER_SUCCESS_TITLE
} from '../content';

import { getFormattedDate } from '../../helper';

class AllocateDifferentDriver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      existingDriverAllocationDate: null,
      existingDriver: null,
      newDriverFirstName: '',
      newDriverSurName: '',
      newDriverLicenceNo: '',
      newDriverIssuingState: '',
      newDriverEmailID: '',
      newDriverMobileNo: '',
      newDriverPayrollNo: '',
      newDriverBusinessMailingAddress: '',
      newDriverAllocationDate: null,
      tabValue: 'existing'
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.driverProfile !== this.props.driverProfile) {
      this.setState({
        existingDriver: nextProps.driverProfile
      });
    }
  }

  onBackClick = () => {
    this.resetDriverDetails();
    this.props.back('differentDriver');
  };

  onCancel = () => {
    this.resetAndClose();
  };

  onAllocate = () => {
    const currentDetails = this.props.vehicleDetails;
    const defaultPreviousDriverPayloadData = {
      CompanyCode: currentDetails.CompanyCode,
      CompanyName: currentDetails.CompanyName,
      CostCentre: currentDetails.CostCentre,
      LeaseId: currentDetails.LeaseId,
      DriverId: currentDetails.DriverId || 0,
      DriverFirstName: currentDetails.DriverFirstName,
      DriverSurname: currentDetails.DriverSurname
    };

    switch (this.state.tabValue) {
      case 'existing': {
        const newDriverData = this.state.existingDriver;
        const allocateEffectiveDate = this.state.existingDriverAllocationDate;
        const payloadData = Object.assign(
          {},
          defaultPreviousDriverPayloadData,
          {
            NewDriverId: newDriverData.DriverId,
            NewDriverFirstName: newDriverData.DriverFirstName,
            NewDriverSurname: newDriverData.DriverSurname,
            EffectiveDateOfChange: allocateEffectiveDate,
            RegistrationNumber: currentDetails.RegistrationNumber
          }
        );

        DriverAllocationApi.allocateExistingDriver(
          this.props.country.value,
          payloadData
        )
          .then(data => {
            if (data.success) {
              pushGAAction(
                'DRIVERALLOCATION',
                `EXISTINGDRV::${currentDetails.RegistrationNumber}::${newDriverData.DriverId}`
              );
              this.props.notify({
                time: 12,
                title: CHANGE_DRIVER_SUCCESS_TITLE,
                message: `Vehicle with Regno ${
                  currentDetails.RegistrationNumber
                } will be allocated to ${newDriverData.DriverFirstName} ${
                  newDriverData.DriverSurname
                } on ${getFormattedDate(allocateEffectiveDate)}`
              });
            } else {
              console.error('failure - existing driver allocation');
            }
            // RESET DATA AND CLOSE
            this.resetAndClose();
          })
          .catch(err => {
            console.log(err);
          });
        break;
      }

      case 'new': {
        const newDriverData = this.state;

        const payloadData = Object.assign(
          {},
          defaultPreviousDriverPayloadData,
          {
            NewDriverFirstName: newDriverData.newDriverFirstName,
            NewDriverSurname: newDriverData.newDriverSurName,
            NewDriverLicenseNumber: newDriverData.newDriverLicenceNo,
            NewDriverState: newDriverData.newDriverIssuingState,
            NewDriverEmail: newDriverData.newDriverEmailID,
            NewDriverMobileNumber: newDriverData.newDriverMobileNo,
            NewDriverPayrollNo: newDriverData.newDriverPayrollNo,
            NewDriverBusinessMailingAddress:
              newDriverData.newDriverBusinessMailingAddress,
            EffectiveDateOfChange: newDriverData.newDriverAllocationDate,
            NewDriverId: 0,
            RegistrationNumber: currentDetails.RegistrationNumber
          }
        );

        DriverAllocationApi.allocateNewDriver(
          this.props.country.value,
          payloadData
        )
          .then(data => {
            if (data.success) {
              pushGAAction(
                'DRIVERALLOCATION',
                `NEWDRV::${currentDetails.RegistrationNumber}`
              );

              this.props.notify({
                time: 12,
                title: CHANGE_DRIVER_SUCCESS_TITLE,
                message: `Vehicle with Regno ${
                  currentDetails.RegistrationNumber
                } will be allocated to ${newDriverData.newDriverFirstName} ${
                  newDriverData.newDriverSurName
                } on ${getFormattedDate(newDriverData.newDriverAllocationDate)}`
              });
            } else {
              console.error('failure - new driver allocation');
            }

            // RESET DATA AND CLOSE
            this.resetAndClose();
          })
          .catch(err => {
            console.log(err);
          });

        break;
      }

      default:
        console.error('invalid mode option');
        break;
    }
  };

  setDriverDetails = e => {
    if (e) {
      const paramName = e.target.name;
      const paramValue = e.target.value;
      this.setState({
        [paramName]: paramValue
      });
    } else {
      console.error('invalid option');
    }
  };

  // generate the buttons for the panel
  getActions = () => ({
    right: [
      {
        label: 'Cancel',
        action: this.onCancel
      },
      {
        label:
          this.state.tabValue === 'existing' ? 'Allocate' : 'Save and Allocate',
        variant: 'secondary',
        action: this.onAllocate,
        disabled:
          (this.state.tabValue === 'existing' &&
            !(
              this.state.existingDriver &&
              this.state.existingDriverAllocationDate
            )) ||
          (this.state.tabValue === 'new' &&
            !(
              this.state.newDriverFirstName &&
              this.state.newDriverSurName &&
              this.state.newDriverEmailID &&
              this.state.newDriverAllocationDate
            ))
      }
    ]
  });

  disableAllocate = () => {
    if (this.state.tabValue === 'existing') {
      return !(
        this.state.existingDriver && this.state.existingDriverAllocationDate
      );
    } else if (this.state.tabValue === 'new') {
      return !(
        this.state.newDriverFirstName &&
        this.state.newDriverSurName &&
        this.state.newDriverEmailID &&
        this.state.newDriverAllocationDate
      );
    }
    return false;
  };

  resetDriverDetails = () => {
    this.setState({
      existingDriverAllocationDate: null,
      existingDriver: null,
      newDriverFirstName: '',
      newDriverSurName: '',
      newDriverLicenceNo: '',
      newDriverIssuingState: '',
      newDriverEmailID: '',
      newDriverMobileNo: '',
      newDriverAllocationDate: null,
      newDriverPayrollNo: '',
      newDriverBusinessMailingAddress: '',
      tabValue: 'existing'
    });
  };

  resetAndClose = () => {
    this.resetDriverDetails();
    this.props.close('differentDriver');
  };

  handleTabChange = object => {
    this.setState({
      tabValue: object.key
    });
  };

  render() {
    const { isOpen } = this.props;

    const { existingDriverAllocationDate, existingDriver } = this.state;
    const existingDriverDetails = {
      existingDriverAllocationDate,
      existingDriver
    };

    const {
      newDriverFirstName,
      newDriverSurName,
      newDriverLicenceNo,
      newDriverIssuingState,
      newDriverEmailID,
      newDriverMobileNo,
      newDriverPayrollNo,
      newDriverBusinessMailingAddress,
      newDriverAllocationDate
    } = this.state;
    const newDriverDetails = {
      newDriverFirstName,
      newDriverSurName,
      newDriverLicenceNo,
      newDriverIssuingState,
      newDriverEmailID,
      newDriverMobileNo,
      newDriverPayrollNo,
      newDriverBusinessMailingAddress,
      newDriverAllocationDate
    };

    const driverDetails = (
      <section>
        <NitroNavBar
          label={ALLOCATION_DETAIL_HEADING}
          action={this.onBackClick}
          noPadding
        />
        <NitroPlaceholder size={30} />

        <AllocateDifferentDriverTabs
          country={this.props.country}
          company={this.props.company}
          existingDriverDetails={existingDriverDetails}
          newDriverDetails={newDriverDetails}
          setDriverDetails={this.setDriverDetails}
          handleTabChange={this.handleTabChange}
          tabValue={this.state.tabValue}
          driverProfile={this.props.driverProfile}
        />
      </section>
    );

    if (!isOpen) {
      return null;
    }

    return (
      <NitroDrawer
        isOpen={isOpen}
        padding="32px"
        width={460}
        close={this.resetAndClose}
        staticFooter
        actions={this.getActions()}
      >
        {driverDetails}
      </NitroDrawer>
    );
  }
}

AllocateDifferentDriver.propTypes = {
  actions: PropTypes.object,
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  back: PropTypes.func,
  vehicleDetails: PropTypes.object,
  country: PropTypes.object,
  company: PropTypes.object,
  notify: PropTypes.func,
  driverProfile: PropTypes.object
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  notify: bindActionCreators(notify, dispatch)
});

export default connect(
  null,
  mapDispatchToProps
)(AllocateDifferentDriver);



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/AllocateDifferentDriver.js